import type { DeeplinkView } from '../store/schema/DeeplinkView';
import { action } from 'satcheljs';

export const showView = action(
    'SHOW_VIEW',
    (
        displayedView: DeeplinkView | undefined,
        itemId?: string,
        account?: string,
        group?: string,
        iCalUId?: string,
        formId?: string
    ) => ({
        displayedView,
        itemId,
        account,
        group,
        iCalUId,
        formId,
    })
);

export const resetRoute = action('resetRoute');

export const changeRoute = action('changeRoute', (view: DeeplinkView) => ({
    view,
}));
